import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { style } from '@vanilla-extract/css';

export const sidebarRoot = style(
  {
    backgroundColor: themeVars.color['surface-base'],
    width: '100%',
    height: '100%',
    borderLeft: `${themeVars.border['width-0125']} solid ${themeVars.color['border-base']}`,
    boxSizing: 'border-box',
    /* Clips content during width animation for smooth drawer open */
    overflow: 'hidden',
  },
  'sidebar-root',
);

export const sidebarRootLayoutRefresh = style(
  {
    border: 'none',
    borderRadius: `${themeVars.radius['10']} ${themeVars.radius['10']} 0 0`,
    marginRight: themeVars.space['150'],
  },
  'sidebar-root-layout-refresh',
);

const TOP_NAVIGATION_HEIGHT = '44px';

export const sidebarRootCompanion = style(
  {
    borderRadius: 0,
    marginRight: 0,
    marginTop: `-${TOP_NAVIGATION_HEIGHT}`,
    height: `calc(100% + ${TOP_NAVIGATION_HEIGHT})`,
    borderLeft: `${themeVars.border['width-0125']} solid ${themeVars.color['border-base']}`,
  },
  'sidebar-root-companion',
);

export const sidebar = style(
  {
    height: '100%',
    width: '100%',
  },
  'sidebar',
);

export const resizeHandleLayoutRefresh = style(
  {
    // Rendered as a flex item outside the overflow:hidden sidebar container.
    // Negative margins let it overlap the content's paddingRight (left) and the
    // sidebar edge (right) so it fills the visual gap without affecting layout.
    position: 'relative',
    width: '14px',
    flexShrink: 0,
    cursor: 'ew-resize',
    marginLeft: `calc(-1 * ${themeVars.space['150']})`,
    marginRight: '-2px',
    zIndex: 41,
    '::after': {
      content: '""',
      position: 'absolute',
      right: '2px',
      top: 0,
      width: '1px',
      height: '100%',
      backgroundColor: themeVars.color['border-base'],
      opacity: 0,
      transition: 'opacity 100ms ease-in-out',
    },
    selectors: {
      '&:hover::after': {
        opacity: 1,
      },
      '&:active::after': {
        opacity: 1,
      },
    },
  },
  'resize-handle-layout-refresh',
);

export const sidebarHeader = style(
  {
    height: '44px',
  },
  'sidebar-header',
);
